export default __webpack_public_path__ + "static/media/cdp_thumb_2.f90ac4ea.png";